export const web_id = 'dynlab'
export const web_name = 'DYNLab'